import { combineReducers } from 'redux';

import { reducer as doctorInfoState } from '../doctorInfo/store';

const hospitalReducer = combineReducers({
    doctorInfoState
});

export default hospitalReducer;


// WEBPACK FOOTER //
// ./src/components/hospital/store/index.js